(function ($) {

    "use strict";




    // Reveal du logo
    //
    var
        logoLines = $('#logo--intro .lines path').toArray(),
        logo = $('#logo--intro'),
        overlay = $('#overlayLogoIntro'),
        logoIntro = new TimelineMax();

    if($('body.home').length){


        logoIntro
            .set(overlay, {height: '100vh', opacity : 1, display : 'block'})
            .call(function(){
                logo.addClass('logo--middle');
            })
            //.set(logo, {position : 'absolute', top :'50%', left:'50%', width : '23rem', x:'-50%', y:'-100%', margin : 0})
            .staggerFromTo(logoLines, 0.5, { opacity : 0},{ opacity : 1, ease : Power4.EaseIn}, 0.1, '+=0.2')
            .staggerTo(logoLines, 0.15, { opacity : 0, ease : Power4.EaseOut}, 0.05, '+=0.2')
            .to(overlay, 0.5,{opacity : 0})
            .set(overlay, {height : 0, display : 'none'},'+=0.5')
            //.set(logo, {top: 0, left: 0, width: '16rem', margin: '4rem 0 0 4rem', transform: 'translateY(0)'})
            .call(function(){
                logo.removeClass('logo--middle');
                logo.addClass('logo--top');
            })
            .staggerFromTo(logoLines, 0.15, {opacity: 0}, {opacity: 1, ease: Power4.EaseOut}, 0.05)
        ;
    }


    /*
    * Template URL
    * */
    var templateUrl = bodyMovinPlugin.templateUrl;



    /*
    * display 1 as 01 dans la pagination
    * */
    function pad(d) {
        return (d < 10) ? '0' + d.toString() : d.toString();
    }



    var generalFunctions = function () {

        // no barba on admin bar
        $('#wpadminbar a').on('click', function (e) {
            e.preventDefault;
            Barba.Pjax.preventCheck = function () {
                return false;
            };
        });

        /*
      * Animations on scroll
      * */

        AOS.init({
            duration : 1500,
            anchorPlacement: 'top-bottom',
            offset : -100
        });

    };

    var homeFunctions = function () {
        console.log('home');


        // création du slider de la home
        //
        var createHomeSlider = function () {
            var sliderHome = new Swiper(".swiper-container", swiperOptions);
            console.log('slider Home init');

            $('.swiper-button-next').click(function (e) {
                e.preventDefault;
                sliderHome.slideNext();
            });

            $('.swiper-button-prev').click(function (e) {
                e.preventDefault;
                sliderHome.slidePrev();
            });
        }


        // Options slider home
        var swiperOptions = {
            loop: true,
            effect: "fade",
            speed: 2000,
            preventClicks: true,
            preventClicksPropagation: true,
            allowTouchMove : true,
            autoplay: {
                delay: 80000000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + '</span>';
                },

            },
        };

        // create the home slider
        createHomeSlider();

    };

    var singleFunctions = function () {
        console.log('single');
    };
    var pageFunctions = function () {
        console.log('pages');
        var typed = new Typed("#typed", {
            stringsElement: '#typed-strings',
            typeSpeed: 70,
            smartBackspace: true,
            onComplete : function(){
                $(".typed-cursor").hide();
            }
        });
    };
    var gallerieFunctions = function () {
        console.log('galleries');

        /*
        *
        * typedjs pour le texte en haut de la galerie
        *
        * */

        var typed = new Typed("#typed", {
            stringsElement: '#typed-strings',
            typeSpeed: 100,
            smartBackspace: true,
            onComplete : function(){
                $(".typed-cursor").hide();
            }
        });
    };


    var singleGalleriesFunctions = function () {
        console.log('single-galleries');

        // Création du slider pour les pages internes
        // Options slider home
        var swiperPagesOptions = {

            loop: true,
            direction: 'vertical',
            spaceBetween: 0,
            // dynamicBullets: true,
            watchOverflow: true,
            parallax: true,
            speed: 2000,
            slidesPerView: 1,
            autoplay: {
                delay : 5000
            },
            allowTouchMove: true,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets',
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + pad((index + 1)) + '</span>';
                },

            },

        };

        var swiperFadeOptions = {
            spaceBetween: 30,
            loop :true,
            effect: 'fade',
            crossFade : true
        };

        if($(".swiper-container--pages").length){
            var sliderPages = new Swiper(".swiper-container--pages", swiperPagesOptions);
            var sliderDescr = new Swiper(".swiper-container--pages__descr", swiperFadeOptions);


            sliderDescr.controller.control = sliderPages;
            sliderPages.controller.control = sliderDescr;

        }




    };

    $(document).ready(function ($) {

        var Homepage = Barba.BaseView.extend({
            namespace: 'home',
            onEnter: function () {
                //console.log('onEnter');
                var pageType = this.namespace;
                console.log(pageType);
            },
            onEnterCompleted: function () {
                generalFunctions();
                homeFunctions();
                //console.log('onEnterCompleted');

            },
            onLeave: function () {
                // A new Transition toward a new page has just started.
            },
            onLeaveCompleted: function () {
                // The Container has just been removed from the DOM.
            }
        });
        Homepage.init();

        var Single = Barba.BaseView.extend({
            namespace: 'single',
            onEnterCompleted: function () {
                var pageType = this.namespace;
                console.log(pageType);
                generalFunctions();
                singleGalleriesFunctions();
                //singleFunctions();
                //pageFunctions();
            }
        });
        Single.init();

        var Gallerie = Barba.BaseView.extend({
            namespace: 'gallerie',
            onEnterCompleted: function () {
                var pageType = this.namespace;
                console.log(pageType);
                generalFunctions();
                //singleFunctions();
                gallerieFunctions();
            }
        });
        Gallerie.init();
        var SingleGalleries = Barba.BaseView.extend({
            namespace: 'single-galleries',
            onEnterCompleted: function () {
                var pageType = this.namespace;
                console.log(pageType);
                generalFunctions();
                //singleFunctions();
                singleGalleriesFunctions();
            }
        });
        SingleGalleries.init();

        var Page = Barba.BaseView.extend({
            namespace: 'page',
            onEnterCompleted: function () {
                var pageType = this.namespace;
                console.log(pageType);
                generalFunctions();
                pageFunctions();
            }
        });
        Page.init();

        Barba.Pjax.start();
        Barba.Prefetch.init();

        // Google Analytics
        Barba.Dispatcher.on('initStateChange', function () {
            if (typeof ga === 'function') {
                ga('send', 'pageview', location.pathname);
            }
        });


        var FadeTransition = Barba.BaseTransition.extend({
            start: function () {
                Promise
                    .all([this.newContainerLoading, this.fadeOut()])
                    .then(this.fadeIn.bind(this));
            },

            fadeOut: function () {
                return $(this.oldContainer).animate({opacity: 0}, 200, function () {
                    $(this.oldContainer).css({height : 0});
                    window.scrollTo(0, 0);
                }).promise();

            },

            fadeIn: function () {

                logo.addClass('top');
                logoIntro

                //.staggerFromTo(logoLines, 0.5, { opacity : 0},{ opacity : 1, ease : Power4.EaseIn}, 0.1, '+=0.2')
                //.staggerTo(logoLines, 0.15, { opacity : 0, ease : Power4.EaseOut}, 0.05, '+=0.2')
                //.to(overlay, 0.5, {opacity: 0})
                //.set(overlay, { display : "none"})
                    //.set(logo, {top: 0, left: 0, width: '16rem', margin: '4rem 0 0 4rem', transform: 'translateY(0)'})
                    //.set(logo, {width: '16rem', transform: 'translateY(0)'})
                    .staggerFromTo(logoLines, 0.15, {opacity: 0}, {opacity: 1, ease: Power4.EaseOut}, 0.05)
                ;
                var _this = this;
                var $el = $(this.newContainer);
                // ajout des body classes
                var bodyClasses = $el.attr('data-classes');
                $('body').removeClass().addClass(bodyClasses);

                $(this.oldContainer).hide();

                window.scrollTo(0, 0);

                $el.css({
                    visibility: 'visible',
                    opacity: 0
                });



                $el.delay('1200').animate({opacity: 1}, 400, function () {

                    _this.done();


                });


            }
        });
        var FromPageTransition = Barba.BaseTransition.extend({
            start: function () {
                Promise
                    .all([this.newContainerLoading,this.fadeOut()])
                    .then(this.display.bind(this));
            },
            fadeOut: function(){
                var deferred = Barba.Utils.deferred();

                /*
               *
               * Test transition GSAP
               *
               * */

                var
                    nextPost = $('.nextPost'),
                    content = $('#content > div'),
                    oldContainer = $(this.oldContainer),
                    postWidth = $('#single__top--wrapper').width(),
                    postHeight = $('#single__top--wrapper').height(),
                    postPosition = $('#single__top--wrapper').position().top,
                    pageTransition = new TimelineMax({ onComplete : function(){ deferred.resolve();}});

                //console.log(postPosition);
                nextPost.addClass('animating');


/*

                pageTransition
                    .set($('body'), {height : '100vh', overflow : 'hidden'})
                    .set(content, { overflow : 'hidden', height:"100vh",  position : "fixed", top : 0, left : 0},'+=1')
                    .to(content, 0.5, {opacity : 0})
                    .to(window, 1, {scrollTo:0 })
                    .to(nextPost, 1, { y : 162, margin : 'auto', ease:Linear.easeNone}, "-=1")
                    .to(content, 1, {height : 0 }, "-=1")
                    .to(nextPost, 1, {height : postHeight, width: postWidth, y : postPosition, ease : Power1.easeInOut}, "+=0.1")

                ;
*/
                pageTransition
                    .set($('body'), {height : '100vh', overflow : 'hidden'})
                    .set(content, { overflow : 'hidden', height:"100vh", /* position : "fixed", top : 0, left : 0*/},'+=1')
                    .to(content, 0.5, {opacity : 0})
                    .to(window, 1, {scrollTo:0 })
                    .to(nextPost, 1, { y : 162, margin : 'auto', ease:Linear.easeNone}, "-=1")
                    .to(content, 1, {height : 0 }, "-=1")
                    .to(nextPost, 1, {height : postHeight, width: postWidth, y : postPosition, ease : Power1.easeInOut}, "+=0.1")

                ;


                if(pageTransition.isActive()){
                    $("#menu").bind("mousewheel", function() {
                        return false;
                    });
                }

                return deferred.promise;

            },
            display: function () {

                var _this = this;
                var $el = $(this.newContainer);


                setTimeout(function(){
                    $(this.oldContainer).hide();

                }, 200);
                $('body').css({
                    height : 'auto',
                    overflow : 'visible'
                });
                $el.css({
                    visibility: 'visible',
                    opacity: 0,
                    position: 'fixed',
                    height : 0,
                    top: '0',
                    left: 0,
                    width: '100%'
                });


                $el.animate({opacity: 1, height: 'auto'}, 500, function () {

                    _this.done(function(){

                    });
                    $el.css({
                       position: 'relative',
                    });


                    // ajout des body classes
                    var bodyClasses = $('.barba-container').attr('data-classes');
                    $('body').removeClass().addClass(bodyClasses);
                });



            }
        });
        $('image_test a').click(function(e){
            e.preventDefault();

        });

        Barba.Dispatcher.on('linkClicked', function (el) {
            Barba.Pjax.getTransition = function () {
                return FadeTransition;
            }
          /*  if($(el).attr('data-namespace') === "single-galleries"){
                Barba.Pjax.getTransition = function () {
                    return FromPageTransition;
                }
            }

            else{
                Barba.Pjax.getTransition = function () {
                    return FadeTransition;
                }
            }
        */
        });

    });


    /*
    *
    * Gestion du menu
    *
    * */

    var menuButton = $('#hamburgerMenu--icon'),
        menuLink = $('#menu-menu-principal .menu-item a'),
        galleryLink = $('#hamburgerMenu > a')
        overlay = $('.overlay');


    // anim bodymovin du menu

    var animMenu = bodymovin.loadAnimation({
        container: document.getElementById('hamburgerMenu--icon'), // Required
        path: templateUrl + '/assets/dist/js/anim-menu.json', // Required
        renderer: 'svg', // Required
        rendererSettings: {
            progressiveLoad: false,
        },
        loop: false, // Optional
        autoplay: false, // Optional
        name: "Anim menu", // Name for future reference. Optional.
    });

    animMenu.setSubframe(false);
    animMenu.setSpeed(1);
    animMenu.addEventListener('DOMLoaded', function () {
        setTimeout(function () {
            animMenu.playSegments([0, 25], true);
        }, 500);

    });


    var menuClose = function () {
        //$('.lines--anime').removeClass('anim').addClass('backwards');
        $('body').removeClass('noScroll');
        $('#overlay').removeClass('active');
        $('#hamburgerMenu ').removeClass('active');
        $('.lines--anime').removeClass('menu-open');
        $('.main-menu').removeClass('menu--open').addClass('backwards');
    };

    var menuOpen = function () {
        //$('.lines--anime').removeClass('backwards').addClass('anim');
        $('body').addClass('noScroll');
        $('#overlay').addClass('active');
        $('#hamburgerMenu').addClass('active');
        $('.lines--anime').addClass('menu-open');
        $('.main-menu').removeClass('backwards').addClass('menu--open');
    };

    /*
    *
    * trigger des anims au click du menu
    *
    * */
    menuButton.click(function (e) {
        e.preventDefault;

        if (animMenu.currentFrame > 24) {
            animMenu.playSegments([55, 24], true);
            menuClose();
        }
        else {
            animMenu.playSegments([35, 61], true);
            menuOpen();
        }
    });

    menuLink.click(function (e) {
        e.preventDefault;

        if (animMenu.currentFrame > 24) {
            animMenu.playSegments([55, 24], true);
            menuClose();
        }
        else {
            animMenu.playSegments([35, 61], true);
            menuOpen();
        }
    });

    galleryLink.click(function (e) {
        e.preventDefault;

        if (animMenu.currentFrame > 24) {
            animMenu.playSegments([55, 24], true);
            menuClose();
        }
    });





})(jQuery);
